import styled, { css } from 'styled-components'
import Typography from '@mui/material/Typography'

export const TypographyStyled = styled(Typography)(
  ({ theme }) => css`
    && {
      font-size: ${theme.typograph.fontsize.h3};
      font-family: ${theme.typograph.fontFamily.primary};
    }
  `
)
